import React from 'react'
import { Switch, Route } from 'react-router-dom'
import slug from 'constants/slug'
import UserList from './user-list'
import UserCreate from './user-create'
import UserEdit from './user-edit'

export default props => (
  <Switch>
    <Route
      exact
      path={slug.user.list}
      render={matchProps => <UserList {...matchProps} {...props} />}
    />
    <Route
      path={slug.user.create}
      render={matchProps => <UserCreate {...matchProps} {...props} />}
    />
    <Route path={slug.user.edit} component={UserEdit} />
  </Switch>
)



// WEBPACK FOOTER //
// ./src/containers/user/index.js